





































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import {
  addWalletMovementConfig,
  AddWalletMovementErrorObject,
  AddWalletMovementInterface,
} from '@modules/wallet/config/wallet-movement-config';

@Component({
  name: 'bc-add-wallet-movement-modal',
  components: {
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-input': Input,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AddWalletMovementModal extends Vue {
  @Prop({ type: String, default: null }) readonly movementType: 'credit' | 'debit';
  @Prop({ type: Number, default: null, required: true }) readonly contactId: number;
  @Prop({ type: Boolean, default: false }) readonly showModal!: boolean;
  @Prop({ type: String, default: 'add-wallet-movement-modal' }) readonly modalId!: string;

  isProcessing = false;
  loading = false;
  formModel: AddWalletMovementInterface = this.initialModel;
  errorsObject: AddWalletMovementErrorObject = {};
  walletId: number = null;
  walletBalance: string = null;
  walletName: string = null;

  get title() {
    return this.movementType === 'credit'
      ? this.$t('virtual_wallet.modals.add_wallet_movement.credit_title')
      : this.$t('virtual_wallet.modals.add_wallet_movement.debit_title');
  }

  get fieldsConfig() {
    return addWalletMovementConfig;
  }

  get paymentMethodTypeFieldConfig() {
    return this.centerCountry === 'fr'
      ? this.fieldsConfig.paymentMethodTypeFR
      : this.fieldsConfig.paymentMethodType;
  }

  get centerCountry(): string {
    return this.$store.getters['centerSettings/centerSettings'].country;
  }

  get initialModel(): AddWalletMovementInterface {
    return {
      amount: 0,
      paymentMethodType: 'money_transfer',
      contactId: 0,
      type: 'credit',
      walletId: null,
      description: null,
    };
  }

  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  closeModal() {
    this.formModel = this.initialModel;
    this.$emit('close-modal');
    this.$bvModal.hide(this.modalId);
  }

  openModal() {
    this.formModel.type = this.movementType;
    this.formModel.contactId = this.contactId;
    this.fetchWallet(this.contactId);
    this.$bvModal.show(this.modalId);
  }

  onChangeErrorObject(field: string) {
    delete this.errorsObject[field];
  }

  movementAdded() {
    this.isProcessing = false;
    this.$emit('wallet-movement-added');
    this.closeModal();
  }

  async addMovement() {
    this.isProcessing = true;
    const uri = `${this.$bpcApiRouteHelper.getEntityPath('wallet-movements')}`;
    const body = this.formModel;
    this.$bpcApi.post(uri, body).subscribe(
      res => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
        this.movementAdded();
      },
      err => {
        if (err.response?.status === 422) {
          this.manageSaveErrors(err.response?.data?.errors);
        }
        this.isProcessing = false;
      },
    );
  }

  async fetchWallet(contactId: number) {
    this.loading = true;
    const uri = `${this.$bpcApiRouteHelper.getEntityPath('contacts')}/${contactId}/wallet`;
    this.$bpcApi.get(uri).subscribe(
      res => {
        this.walletBalance = res.data.balance.amount;
        this.walletId = res.data.id;
        this.walletName = res.data.name;
        this.formModel.walletId = this.walletId;
        this.loading = false;
      },
      err => {
        this.walletBalance = null;
        this.walletId = null;
        this.walletName = null;
        this.formModel.walletId = null;
        this.loading = false;
      },
    );
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    if (!errors) {
      return;
    }
    Object.keys(errors).forEach(key => {
      const aux = {
        error: errors[key][0],
        state: false,
      };
      this.$set(this.errorsObject, key, aux);
    });
  }
}
